import { gql } from '@apollo/client';

export const GET_CREDIT_FACILITIES_BY_ORGANIZATION = gql`
  query GetCreditFacilitiesByOrganization(
    $organizationId: UUID!
    $creditFacilitySlugsToHide: [String!]!
  ) {
    organization(
      organizationId: $organizationId
      creditFacilitySlugsToHide: $creditFacilitySlugsToHide
    ) {
      id
      creditFacilities {
        id
        borrowerId
        name
        isActive
        slug
        type
        implementationId
      }
    }
  }
`;
